(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fn-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fn-banner')) {
    customElements.define(
      'fn-banner',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('.fn-banner__slide')];
          this.dots = [...this.querySelectorAll('.fn-banner__dot')];
          this.i = 0;
          if (this.slides.length < 2) return;
          this.dots.forEach((d) => d.addEventListener('click', () => this.go(+d.dataset.index, true)));
          const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.auto = this.dataset.autoplay === 'true' && !calm;
          this.speed = +this.dataset.speed || 6000;
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          let x = null;
          this.addEventListener('touchstart', (e) => (x = e.touches[0].clientX), { passive: true });
          this.addEventListener('touchend', (e) => {
            if (x === null) return;
            const dx = e.changedTouches[0].clientX - x;
            if (Math.abs(dx) > 40) this.go(this.i + (dx < 0 ? 1 : -1), true);
            x = null;
          });
          document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
          this.start();
        }
        go(n, user) {
          const len = this.slides.length;
          n = (n + len) % len;
          if (n === this.i) return;
          this.slides[this.i].classList.remove('is-active');
          this.slides[this.i].setAttribute('aria-hidden', 'true');
          this.dots[this.i]?.classList.remove('is-active');
          this.i = n;
          this.slides[n].classList.add('is-active');
          this.slides[n].removeAttribute('aria-hidden');
          this.dots[n]?.classList.add('is-active');
          if (user) this.start();
        }
        start() {
          this.stop();
          if (this.auto) this.timer = setInterval(() => this.go(this.i + 1), this.speed);
        }
        stop() {
          clearInterval(this.timer);
        }
        disconnectedCallback() {
          this.stop();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
